import { render, staticRenderFns } from "./PriceContainer.vue?vue&type=template&id=66a3ef9a&"
import script from "./PriceContainer.vue?vue&type=script&lang=js&"
export * from "./PriceContainer.vue?vue&type=script&lang=js&"
import style0 from "./PriceContainer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports